import { render, staticRenderFns } from "./d-leaderboard-feed.vue?vue&type=template&id=46ffc866&scoped=true&"
import script from "./d-leaderboard-feed.vue?vue&type=script&lang=js&"
export * from "./d-leaderboard-feed.vue?vue&type=script&lang=js&"
import style0 from "./d-leaderboard-feed.vue?vue&type=style&index=0&id=46ffc866&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ffc866",
  null
  
)

export default component.exports